import type { Bordereau, Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BaseBordereauState from './BaseBordereauState';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import BordereauStatutAnterieurAction from '../actions/BordereauStatutAnterieurAction';

class BordereauRejeteState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.REJETE;
    this.state = BordereauStateType.REJETE;
    this.color = '#A0A0A0';
    this.libelle = 'Rejeté par la collectivité';
  }

  getBordereauActions(_bordereau : Bordereau, userRole : UserRole): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
      new BordereauDupliquerAction({ isActionPrincipale: true }),
      ...(userRole === UserRole.ADMIN) ? [
        new BordereauModifierAction({ isSuperUser: true }),
        new BordereauStatutAnterieurAction({ isSuperUser: true }),
      ] : [],
    ];
  }

  getMouvementActions(userRole : UserRole): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
      new MouvementModifierAction({ isReadonly: true }),
      new MouvementDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new MouvementModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }
}

export default BordereauRejeteState;
